angular.module('psModule').controller('SimulatePensionCtrl', function($scope, $state, $filter, $uibModal, $resource, simulationService, benefitService, bssimulationService, calculationParamsService, $anchorScroll, Message){
    $anchorScroll.yOffset = 20;
    $scope.dataLoaded = false;
    $scope.activePensionId = -1;
    $scope.chartSeries = '';
    $scope.chartCategories = [];
    $scope.isReadonly = capitexIsActive();

    var graphMaxDisplayAge = 90;
    var graphMinAgeMinOffset = 3;

    $scope.savedSimulations = [];

    bssimulationService.isActive().$promise.then(function (response) {
        if (response.isActive) {
            $state.go('retirementSimulation');
        } else {
            init();
        }
    });

    function init() {
        setupDefaultGlobalValues();

        benefitService.getFbesked().then(function (fbesked) {
            $scope.hasSalary = !!fbesked.assumptions.dateradArslon;
            if ($scope.hasSalary) {
                simulationService.getDefaultPensionSimulations(function (data) {
                    resolveSimulationData(data);
                    $scope.getSavedSimulations();
                    $scope.dataLoaded = true;
                });
            } else {
                Message.error('ps_missingCustomerInfoMessage_title', 'ps_missingCustomerInfoMessage_text', 'noSalaryErr');
            }
        }, function () {
            Message.error('ps_missingCustomerInfoMessage_title', 'ps_missingCustomerInfoMessage_text', 'noSalaryErr');
        });
    }

    function getInfoForMomentModal(pension, fbesked) {
        var forsakringsbeloppList = fbesked.categoryMap["Alderspension"].subCategoryMap["per_man_tax"].forsakringsbeloppList;
        for (var i = 0; i < forsakringsbeloppList.length; i++) {
            if (forsakringsbeloppList[i].header === pension.name) {
                return forsakringsbeloppList[i];
            }
        }
        return null;
    }

    function setupDefaultGlobalValues() {
        $scope.model = {
            allPensionDurationDefault : undefined,
            globalDurationEdited : false
        };
    }

    function getTaxInfoColor(taxLimit, highestTotalMonthlyPayment) {
        if (highestTotalMonthlyPayment >= taxLimit) {
            return '#f60000';
        }
        return '#00f600';
    }

    function getSimulationData(data) {
        var simulation = angular.copy(data);
        for (var i = 0; i < simulation.pensionGroups.length; i++) {
            for (var j = 0; j < simulation.pensionGroups[i].pensions.length; j++) {
                var pension = simulation.pensionGroups[i].pensions[j];
                pension.retirementAgeSlider = pension.retirementAge;
                pension.durationSlider = pension.duration;
                pension.lastPremiumAgeSlider = pension.lastPremiumAge;
            }
        }
        return simulation;
    }

    function resolveSimulationData(data) {
        $scope.simulation = getSimulationData(data);
        $scope.originalSimulation = angular.copy($scope.simulation);
        $scope.model.allPensionDurationDefault = $scope.simulation.allPensionDuration > 5 ? $scope.simulation.allPensionDuration : undefined;

        calculationParamsService.get().then(function(calcParam) {
            var incomeTaxBreakpointBefore65 = !!calcParam['com_income_tax_breakpoint_before_65'] ? calcParam['com_income_tax_breakpoint_before_65'] / 12.0 : 99999999;
            var incomeTaxBreakpointFrom65 = !!calcParam['com_income_tax_breakpoint_from_65'] ? calcParam['com_income_tax_breakpoint_from_65'] / 12.0 : 99999999;

            $scope.incomeTaxLimitBefore65 = {
                value: incomeTaxBreakpointBefore65,
                color: getTaxInfoColor(incomeTaxBreakpointBefore65, data.highestTotalMonthlyPayment)
            };
            $scope.incomeTaxLimitFrom65 = {
                value: incomeTaxBreakpointFrom65,
                color: getTaxInfoColor(incomeTaxBreakpointFrom65, data.highestTotalMonthlyPayment)
            };
        });

        $scope.resolveChartData(data.pensionGroups);
    }

    function getOldAndNewValues(pensionID, field) {
        for (var i = 0; i < $scope.simulation.pensionGroups.length; i++) {
            for (var j = 0; j < $scope.simulation.pensionGroups[i].pensions.length; j++) {
                var pension = $scope.simulation.pensionGroups[i].pensions[j];
                if (pension.pensionID === pensionID) {
                    if (pension[field] === '') {
                        // Empty values are not allowed, reset to old value.
                        pension[field] = $scope.originalSimulation.pensionGroups[i].pensions[j][field];
                    }

                    return {
                        old: $scope.originalSimulation.pensionGroups[i].pensions[j][field],
                        new: pension[field]
                    };
                }
            }
        }
        return {
            old: "",
            new: ""
        };
    }

    $scope.updateGlobalDuration = function() {
        var allPensionDuration = parseInt($scope.model.allPensionDurationDefault);
        if(!isNaN(allPensionDuration)) {
            $scope.simulation.allPensionDuration = allPensionDuration;
            $scope.generalChange('allPensionDuration');
            $scope.model.globalDurationEdited = true;
        }
    };

    $scope.getGroupColor = function (benefitType) {
        if (benefitType === 'NationalPension') {
            return "#EBB04D";
        } else if (benefitType === 'OccupationalPension') {
            return "#4968C0";
        } else if (benefitType === 'PrivatePension') {
            return "#77A7F6";
        } else {
            return "#C0C0C0";
        }
    };

    function getChartIndex(benefitType) {
        if (benefitType === 'NationalPension') {
            return 3;
        } else if (benefitType === 'OccupationalPension') {
            return 2;
        } else if (benefitType === 'PrivatePension') {
            return 1;
        } else {
            return 0;
        }
    }

    $scope.setActivePensionId = function(id) {
        if (id === $scope.activePensionId) {
            $scope.activePensionId = -1;
        } else {
            $scope.activePensionId = id;
        }
    };

    $scope.momentDetails = function(pension) {
        benefitService.getFbesked().then(function(fbesked) {
            var info = getInfoForMomentModal(pension, fbesked);
            if (info === null) {
                $uibModal.open({
                    template:'<div><div class="modal-header" ng-if="header"><button type="button" class="close pull-right" ng-click="$dismiss()" aria-hidden="true">&times;</button><h2 class="modal-title">{{header | translate}}</h2></div><div class="modal-body"><div ng-bind-html="body"></div></div><div class="modal-footer"><button class="btn btn-default" ng-click="$dismiss()">{{\'ps_close\' | translate}}</button></div></div>',
                    controller: 'SimpleModalCtrl',
                    size: 'lg',
                    resolve: {
                        header: function () { return pension.name; },
                        body: function () { return "Ingen information kan visas."; }
                    }
                });
            } else {
                $uibModal.open({
                    template:'<div><div class="modal-header"><button type="button" class="close pull-right" ng-click="$dismiss()" aria-hidden="true">&times;</button><h2 class="modal-title">{{fbelopp.header}}</h2></div><div class="modal-body"><div><div class="info" ng-bind-html="fullDescHtml"></div></div><div ng-if="sparplan && sparplan.innehav.length > 0"><h2>{{\'fb_share_of_capital\' | translate}} <small class="header-note pull-right"><ps-date value="sparplan.valueDate"></ps-date></small></h2><div class="well info"><div class="mm-panel"><table class="table table-striped"><thead><tr><th>{{\'fb_fund_name\' | translate}}</th><th class="text-right">{{\'fb_share_of_capital\' | translate}}</th><th class="text-right">{{\'fb_share_of_premium\' | translate}}</th><th class="text-right">{{\'ps_value_sek\' | translate}}</th></tr></thead><tbody><tr ng-repeat="sparfordelning in sparplan.innehav"><td><ps-fund-details-link fund="getFund(sparfordelning)" name="sparfordelning.innehav.name"></ps-fund-details-link></td><td class="no-line-break text-right">{{ ::sparfordelning.shareOfCapitalWithPrecision | percentage:2:true}}</td><td class="no-line-break text-right"><span ng-if="sparfordelning.shareOfPremiumWithPrecision">{{ ::sparfordelning.shareOfPremiumWithPrecision | percentage:2:true}}</span> <span ng-if="!sparfordelning.shareOfPremiumWithPrecision">-</span></td><td class="text-right"><ps-amount value="sparfordelning.innehav.value"></ps-amount></td></tr></tbody><tfoot><tr><td colspan="4" class="text-right"><strong>{{\'ps_sum\' | translate}}:&nbsp;<ps-amount value="sparplan.totalValue"></ps-amount></strong></td></tr></tfoot></table><div ng-if="forsakring.metaData.canReallocate && !forsakring.metaData.isChangeable" class="alert alert-warning">{{"fb_change_funds_disabled" | translate}}</div><ps-fundchange-button ng-if="forsakring.metaData.canReallocate" insurance="forsakring"></ps-fundchange-button></div></div></div></div><div class="modal-footer"><div class="pull-left text-muted" ng-if="fbelopp.insuranceCompany && fbelopp.importDate"><small>{{\'fb_information_from\' | translate}}&nbsp;{{fbelopp.insuranceCompany}}&nbsp;<ps-date value="fbelopp.importDate"></ps-date></small></div><button class="btn btn-default" ng-click="$dismiss()">{{\'ps_close\' | translate}}</button></div></div>',
                    controller: 'momentModalCtrl',
                    size: 'lg',
                    resolve: {
                        fbelopp: function () { return info; }
                    }
                });
            }
        }, function () {
            Message.error('ps_missingCustomerInfoMessage_title','ps_missingCustomerInfoMessage_text', 'noSalaryErr');
        });

    };

    $scope.removeSavedSimulation = function (simulationID) {
        simulationService.removeSavedSimulation(simulationID, function (data) {
            $scope.savedSimulations = data;
        });
    };

    $scope.getSavedSimulations = function () {
        simulationService.getSavedSimulations(function (data) {
            $scope.savedSimulations = data;
        });
    };

    $scope.loadSavedSimulation = function (simulation) {
        $scope.activeSavedSimulation = simulation;
        resolveSimulationData(simulation.simulation);
        $anchorScroll('simulation-header');
    };


    $scope.addSimulatedInsurance = function () {
        simulationService.addSimulatedInsurance(function (data) {
            resolveSimulationData(data);
        });
    };

    $scope.removeInsurance = function (pensionID) {
        simulationService.removeSimulatedInsurance(pensionID, function (data) {
            resolveSimulationData(data);
        });
    };

    $scope.generalChange = function (field) {
        if (field === 'allPensionDuration') {
            $scope.globalDurationEdited = true;
        }
        var oldValue = $scope.originalSimulation[field];
        var newValue = $scope.simulation[field];

        if (newValue === oldValue) {
            // No change, unnecessary to recalculate.
            return;
        }

        if (newValue === '') {
            // Empty values are not allowed, reset to earlier value
            $scope.simulation[field] = oldValue;
            return;
        }

        if (field === 'allPensionDuration') {
            $scope.model.globalDurationEdited = true;
            $scope.model.allPensionDurationDefault = newValue;
        }

        simulationService.recalculate({field: field, value: newValue}, function (data) {
            $scope.safeApply(function(){
                resolveSimulationData(data);
                $scope.$broadcast('redraw');
            });
        });
    };

    $scope.sliderChange = function (pensionID, field) {
        for (var i = 0; i < $scope.simulation.pensionGroups.length; i++) {
            for (var j = 0; j < $scope.simulation.pensionGroups[i].pensions.length; j++) {
                var pension = $scope.simulation.pensionGroups[i].pensions[j];
                if (pension.pensionID === pensionID) {
                    var newValue = $scope.simulation.pensionGroups[i].pensions[j][field + "Slider"];
                    $scope.simulation.pensionGroups[i].pensions[j][field] = newValue;
                    $scope.simulation.pensionGroups[i].pensions[j][field + "InputHide"] = false;
                    recalculate(pensionID, field, newValue);
                    return;
                }
            }
        }
    };

    $scope.pensionChange = function (pensionID, field) {
        var oldAndNewValues = getOldAndNewValues(pensionID, field);

        if (oldAndNewValues.new === oldAndNewValues.old) {
            // No change, unnecessary to recalculate
            return;
        }

        recalculate(pensionID, field, oldAndNewValues.new);
    };

    function recalculate(pensionID, field, newValue) {
        simulationService.recalculate({pensionID: pensionID, field: field, value: newValue}, function (data) {
            $scope.safeApply(function(){
                resolveSimulationData(data);
                $scope.$broadcast('redraw');
            });
        });
    }

    var getChartRange = function(data) {
        var minAge = graphMaxDisplayAge;
        var maxAge = 60;
        for (var i = 0; i < data.length; i++) {
            var pensionCategory = data[i];
            var pensionArray = pensionCategory.pensions;
            for (var j = 0; j < pensionArray.length; j++) {
                var pension = pensionArray[j];
                minAge = Math.min(pension.retirementAge - graphMinAgeMinOffset, minAge);
                maxAge = Math.max(pension.retirementAge + pension.duration, maxAge);
            }
        }
        maxAge = Math.min(maxAge, graphMaxDisplayAge);
        return {
            minAge: minAge,
            maxAge: maxAge
        };
    };

    var getChartCategories = function (pensionLowerLimit, pensionUpperLimit) {
        var chartCategories = [];
        for (var i = pensionLowerLimit; i <= pensionUpperLimit; i++) {
            chartCategories.push(i+"");
        }
        return chartCategories;
    };

    $scope.resolveChartData = function (data) {
        var chartRange = getChartRange(data);
        var pensionLowerLimit = chartRange.minAge;
        var pensionUpperLimit = chartRange.maxAge;

        $scope.chartCategories = getChartCategories(pensionLowerLimit, pensionUpperLimit);

        var resolvedData = [];
        var pensionMaxDuration = pensionUpperLimit - pensionLowerLimit;
        for (var i = 0; i < data.length; i++) {
            var pensionCategory = data[i];
            var pensionArray = pensionCategory.pensions;
            var dataArray = [];
            for (var k = 0; k <= pensionMaxDuration; k++) {
                dataArray[k] = 0;
            }
            for (var j = 0; j < pensionArray.length; j++) {
                var pension = pensionArray[j];
                var payment = pension.monthlyPayment;
                var retirementAge =  pension.retirementAge;
                var duration = pension.duration;
                if (pension.lifeDuration) {
                    duration = 99;
                }
                var startPayment = retirementAge - pensionLowerLimit;
                var endPayment = Math.min(startPayment + duration - 1, pensionMaxDuration);
                for (k = startPayment; k <= endPayment; k++) {
                    dataArray[k] =  dataArray[k] + payment;
                }
            }

            var obj = {
                name: 'ps_pensionGroup_type-' + pensionCategory.benefitType,
                data: dataArray,
                color: $scope.getGroupColor(pensionCategory.benefitType),
                index: getChartIndex(pensionCategory.benefitType),
                stack: 'first'
            };
            resolvedData.push(obj);
        }
        $scope.chartSeries = resolvedData;
        $scope.$broadcast('redraw');
    };

    $scope.getInitialSimulation = function () {
        setupDefaultGlobalValues();
        simulationService.getDefaultPensionSimulations(function (data) {
            resolveSimulationData(data);
            $scope.activeSavedSimulation = undefined;
            $anchorScroll('simulation-header');
        });
    };

    $scope.openPensionNaming = function() {
        var modal = $uibModal.open({
            template:'<div><form novalidate class="form" name="simulationForm" ng-submit="save(simulationName)"><div class="modal-header"><button type="button" class="close pull-right" ng-click="$dismiss()" aria-hidden="true">&times;</button><h1 class="modal-title" translate="sim_save_header"></h1></div><div class="modal-body save-simulation-margins"><p translate="sim_save_info"></p><div class="form-group" ng-class="{\'has-error\': simulationForm.$submitted && simulationForm.simulationName.$invalid}"><label class="col-sm-2 control-label" for="simulationName" translate="sim_saved_header_name"></label><div class="col-sm-7"><input type="text" class="form-control input-sm" id="simulationName" name="simulationName" ng-model="simulationName" required ng-minlength="3"><ng-messages for="simulationForm.simulationName.$error" ng-if="simulationForm.$submitted && simulationForm.simulationName.$invalid" role="alert"><ng-message class="error-validation" when="required"><span translate="sim_save_name_missing"></span></ng-message><ng-message class="error-validation" when="minlength"><span translate="sim_save_name_length"></span></ng-message><ng-message class="error-validation" when="uniqueName"><span translate="sim_save_name_not_unique"></span></ng-message></ng-messages></div></div></div><div class="modal-footer"><button class="btn btn-default" type="button" ng-click="$dismiss()" translate="sim_button_cancel"></button> <button class="btn btn-primary" type="submit" translate="sim_button_save"></button></div></form></div>',
            size: 'lg',
            backdrop: 'static',
            controller: function ($scope) {
                $scope.save = function (simulationName) {
                    $scope.simulationForm.simulationName.$setValidity("uniqueName", true);

                    if ($scope.simulationForm.$invalid) {
                        return;
                    }

                    simulationService.hasUniqueName({field: simulationName}, function () {
                        $scope.$close(simulationName);
                    }, function () {
                        $scope.simulationForm.simulationName.$setValidity("uniqueName", false);
                    });
                }
            }
        });

        modal.result.then(function (name) {
            var requestData = {name: name, payload: $scope.simulation};
            simulationService.saveSimulation(requestData, function (data) {
                $scope.savedSimulations = data;
            });
        })
    };

    function capitexIsActive() {
        return $scope.$root.config && $scope.$root.config.toggles && $scope.$root.config.toggles.USE_CAPITEX === true;
    }
});
